export const CONFIRM_MODAL_TITLE = {
  SUCCESS_RESET: "비밀번호 변경",
  PHONE_CHANGE: "휴대폰 번호 변경",
  CHECK_PHONE: "휴대폰 번호 확인",
  MODIFY_RESET: "수정 정보 초기화",
  USER_SAVE: "회원 정보 저장",
};
export const CONFIRM_MODAL_EXPLAIN = {
  SUCCESS_RESET: "비밀번호가 성공적으로 변경 되었습니다.",
  PHONE_CHANGE: "휴대폰 번호가 성공적으로 변경 되었습니다.",
  CHECK_PHONE: "현재 등록되어있는 휴대폰 번호와 동일합니다.",
  MODIFY_RESET: "수정하기 이전 정보로 초기화 하시겠습니까?",
  USER_SAVE: "수정하신 내용으로 회원 정보를 저장하시겠습니까?",
};
